var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.875 9.6875C18.875 10.894 18.6374 12.0887 18.1756 13.2034C17.7139 14.3181 17.0372 15.3309 16.184 16.184C15.3309 17.0372 14.3181 17.7139 13.2034 18.1756C12.0887 18.6374 10.894 18.875 9.6875 18.875C8.48098 18.875 7.28627 18.6374 6.1716 18.1756C5.05692 17.7139 4.04409 17.0372 3.19096 16.184C2.33782 15.3309 1.66107 14.3181 1.19936 13.2034C0.737641 12.0887 0.5 10.894 0.5 9.6875C0.5 7.25082 1.46797 4.91395 3.19096 3.19096C4.91395 1.46797 7.25082 0.5 9.6875 0.5C12.1242 0.5 14.4611 1.46797 16.184 3.19096C17.907 4.91395 18.875 7.25082 18.875 9.6875Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 21.5L18.875 18.875L21.5 21.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 21.5L18.875 18.875",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/search.icon.05a4aad497ae86da974a1f52f91419dc.svg";
export { ForwardRef as ReactComponent };